import React from 'react';
import { Switch, Route } from 'react-router-dom';

import Home from './Home';
import Stats from './stats';
import Players from './players';
import PlayersQvneaAll from './playersQvneaAll';
import PlayerAdmin from './admin/players/PlayerAdmin';
import QvneaBooks from './admin/customers/QvneaBooks';
import QvneaBooksOperationsCSV from './admin/customers/QvneaBooksOperationsCSV';

import Standings from './standings/Standings';
import TeamRosters from './standings/TeamRosters';
import LiveScoresheets from './scoresheets/LiveScoresheets';
import RateSysForm from './standings/RateSysForm';
import Scoresheet from './scoresheets/Scoresheet';

import TableauDemo from './dashboard/tableauDemo';
import PlayerDashboard from './dashboard/playerDashboard';
import UserAccount from './users/UserAccount';
import UserAccountSandbox from './users/UserAccountSandbox';
import Profile from './users/Profile';
import QuebecOpenLeaderboards2018 from './special/QuebecOpenLeaderboards2018';
import QuebecOpenLeaderboards2019 from './special/QuebecOpenLeaderboards2019';
import QuebecOpenLeaderboards2020 from './special/QuebecOpenLeaderboards2020';
import QuebecInvLeaderboards2023 from './special/QuebecInvLeaderboards2023';

import MontQvnea from './customers/qvnea/MontQvnea';
import PredatorTour from './customers/qvnea/PredatorTour';

//import Confidentialite from './confidentialite';
import PrivacyPolicy from './PrivacyPolicy';
import Termes from './termes';

import Admin from './admin/Admin';


class Main extends React.Component {

  constructor(props) {
		super(props);
	}

	render() {
		//console.log('MAIN this.props')
		//console.log(this.props)

		return (
			<div className="main margin-top-main">
				<div className="container-fluid">
 
					<Switch>
					{/* Main Routes */}
					<Route path="/" exact component={Home} />
					<Route path="/home" exact component={Home} />
					<Route path="/stats" exact component={Stats} />

					{/* Add auth for players page */} 
					<Route path="/players" exact render={(props) => 
						<Players history={this.props.history} auth={this.props.auth} />} />
					
					{/*<Route path="/playersQvneaAll" exact render={(props) => <PlayersQvneaAll auth={this.props.auth} />} />*/}
					
					<Route path="/players/:plid" exact render={(props) => <PlayerAdmin {...props} auth={this.props.auth} />} />

					{/*<Route path="/standings/:seasonid" component={Standings} />*/}
					<Route path="/standings/:seasonid" render={(props) => <Standings {...props} auth={this.props.auth}/> }/>

					<Route path="/teamRosters/:seasonid" exact render={(props) => <TeamRosters {...props} auth={this.props.auth} />} />
					<Route path="/liveScoresheets/:seasonid" exact render={(props) => <LiveScoresheets {...props} auth={this.props.auth} />} />
					<Route path="/scoresheet/:scheduledMatchId" exact render={(props) => <Scoresheet {...props} auth={this.props.auth} />} />

					<Route path="/rateSysForm/:seasonid" exact render={(props) => <RateSysForm {...props} />} />

					{/* This is how I can pass some props ? */}
					{/*<Route path="/playerDashboard" component={PlayerDashboard} />*/}
					<Route path="/playerDashboard" render={(props) => <PlayerDashboard auth={this.props.auth}/> }/>

					{/* onEnter replacement in React Router 4*/}
					{/* https://stackoverflow.com/questions/47627818/performing-authentication-on-routes-with-react-router-v4 */}
					{/* https://stackoverflow.com/questions/45429963/onenter-prop-in-react-router-v4/45430656#45430656 */}
					<Route path="/userAccount" render={(props) => 
						<UserAccount history={this.props.history} auth={this.props.auth} />} />
					<Route path="/userAccountSandbox" render={(props) => 
						<UserAccountSandbox history={this.props.history} auth={this.props.auth} />} />

					<Route path="/profile" render={(props) => <Profile history={this.props.history} auth={this.props.auth} />} />

					<Route path="/admsafe" render={(props) => <Admin {...props} auth={this.props.auth}/>} />

					<Route path="/special/QuebecOpenLeaderboards2018" component={QuebecOpenLeaderboards2018} />
					<Route path="/special/QuebecOpenLeaderboards2019" component={QuebecOpenLeaderboards2019} />
					<Route path="/special/QuebecOpenLeaderboards2020" component={QuebecOpenLeaderboards2020} />
					<Route path="/special/QuebecInvLeaderboards2023" component={QuebecInvLeaderboards2023} />

					<Route path="/qvnea/mont-qvnea" exact render={(props) => <MontQvnea {...props} auth={this.props.auth} />} />
					<Route path="/qvnea/qvnea-books" exact render={(props) => <QvneaBooks {...props} history={this.props.history} auth={this.props.auth} />} />
					<Route path="/qvnea/qvnea-books/csv" exact render={(props) => <QvneaBooksOperationsCSV {...props} history={this.props.history} auth={this.props.auth} />} />

					<Route path="/qvnea/predator-tour" exact render={(props) => <PredatorTour {...props} auth={this.props.auth} />} />

					<Route path="/tableau-de-bord" exact component={TableauDemo} />
					
					<Route path="/confidentialite" exact component={PrivacyPolicy} />
					<Route path="/termes-et-conditions" exact component={Termes} />

					</Switch>
				</div>
			</div>
		)
	}
}

export default Main;

//         			<Route path="/playerDashboard" render={(props) => <PlayerDashboard {...this.props} />} />
